<script setup>
import { Euro, Truck, ChefHat, ShieldCheck, Package, Leaf, CalendarDays } from 'lucide-vue-next';

// Arguments de réassurance du bandeau défilant. Source unique partagée par
// l'accueil natif et l'accueil web : les deux doivent dire exactement la même
// chose, et une promesse ne doit se corriger qu'à un seul endroit.
const BADGES = [
  { icon: Euro,         label: '14 € / repas, livraison incluse',    cls: 'bg-pink-50/80 text-[#e94591]' },
  { icon: Truck,        label: 'Livraison offerte bassin Annécien',  cls: 'bg-[#ecfdf5]/80 text-[#047857]' },
  { icon: ChefHat,      label: '100% fait maison',                   cls: 'bg-pink-50/80 text-[#e94591]' },
  { icon: ShieldCheck,  label: 'Sans engagement',                    cls: 'bg-yellow-50/80 text-[#ca8a04]' },
  { icon: Package,      label: 'Sous-vide',                          cls: 'bg-blue-50/80 text-[#0077B6]' },
  { icon: Leaf,         label: 'Produits locaux',                    cls: 'bg-[#ecfdf5]/80 text-[#047857]' },
  { icon: CalendarDays, label: 'Menu renouvelé',                     cls: 'bg-blue-50/80 text-[#0077B6]' }
];

// L'animation translate la piste de -50% : la liste doit donc être présente
// exactement deux fois pour que la boucle soit sans couture.
const PISTE = [...BADGES, ...BADGES];
</script>

<template>
  <div class="marquee-fenetre relative">
    <div class="flex gap-2 animate-marquee whitespace-nowrap">
      <span v-for="(b, i) in PISTE" :key="i"
            :class="['shrink-0 inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-semibold', b.cls]">
        <component :is="b.icon" class="w-4 h-4" />{{ b.label }}
      </span>
    </div>
  </div>
</template>

<style scoped>
.marquee-fenetre {
  overflow: hidden;
}

@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.animate-marquee {
  animation: marquee 18s linear infinite;
}

/* Sans animation, la piste dépasserait sans aucun moyen d'en voir la fin :
   on rend la lecture manuelle possible. overflow-y explicite car un seul axe
   en `auto` force l'autre à devenir scrollable lui aussi. */
@media (prefers-reduced-motion: reduce) {
  .animate-marquee { animation: none; }
  .marquee-fenetre {
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
  }
  .marquee-fenetre::-webkit-scrollbar { display: none; }
}
</style>
